import {
    GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS,
    GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED,
    RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN,
    LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN,
    NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetGetUserNameContactSuggestionForAdmin = () => {
    return { type: RESET_GETUSERNAMECONTACTSUGGESTIONFORADMIN };
};

const getUsernameContactsSuggestionForAdminList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUSERNAMECONTACTSUGGESTIONFORADMIN });
    await adminServices
        .post("getUsernameContactSuggestionForAdmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(GetUsernameContactSuggestionForAdminsuccess(res.data));
                    break;
                default:
                    dispatch(GetUsernameContactSuggestionForAdminFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETUSERNAMECONTACTSUGGESTIONFORADMIN,
                payload: err
            });
        });
};


function GetUsernameContactSuggestionForAdminsuccess(data) {
    return {
        type: GETUSERNAMECONTACTSUGGESTIONFORADMIN_SUCCESS,
        payload: data
    };
}
function GetUsernameContactSuggestionForAdminFailed(data) {
    return {
        type: GETUSERNAMECONTACTSUGGESTIONFORADMIN_FAILED,
        payload: data
    };
}

export { getUsernameContactsSuggestionForAdminList, resetGetUserNameContactSuggestionForAdmin }